import React from 'react'


export const TributePage = () => {
    return (
        <div>
            <br />
            <h1 id="title">Eiichiro Oda</h1>
            <p>Japanese Mangaka</ p>
            <div id="img-div">
                <img src="https://external-preview.redd.it/hQWOyKgUpOEASjr3_Fo7ej6Zj8bMARZNpk7RmdxTaqM.jpg?auto=webp&s=f2cc54cc5b7568b7f0020788214df1ef5b7f5976" id="image"></img>
                <figcaption id="img-caption">Eiichiro Oda showing, discussing and creating artworks; he adds a fan request drawing in each One Piece's manga's first page.</figcaption>
            </div>
            <h2 id="tribute-info">Here is a timeline of the Mangaka's life</h2>
            <container>
                <ul>
                    <li><strong>1975</strong> - Born in Kumamoto, Japan.</li>
                    <li><strong>1992</strong> - At the age of 17, Oda submitted his work Wanted!" and won several awards, including second place in the coveted Tezuka Award</li>
                    <li><strong>1994</strong> - At the age of 19, he began working as an assistant to Nobuhiro Watsuki on Rurouni Kenshin, before winning the Hop Step Award for new manga artists. Watsuki credits Oda for helping create the character Honjō Kamatari who appears in Rurouni Kenshin.</li>
                    <li><strong>1996</strong> - Since his work with Watsuki, Oda drew two pirate-themed one-shot stories called "Romance Dawn", which were published in Akamaru Jump and Weekly Shōnen Jump respectively.  "Romance Dawn" featured Monkey D. Luffy as the protagonist, who then became the protagonist of One Piece.</li>
                    <li><strong>1997</strong> -
                        One Piece began serialization in Weekly Shōnen Jump</li>
                    <li><strong>2005</strong> - 100 One Piece million collected tankōbon volumes sold</li>
                    <li><strong>2011</strong> - Over 200 million collected One Piece tankōbon volumes sold</li>
                    <li><strong>2014</strong> - 320,866,000 One piece copies printed worldwide</li>
                    <li><strong>2017</strong> - 430 million One piece copies printed worldwide.</li>
                    <li><strong>2019</strong> - 450 million One Piece copies in print as of March 2019.</li>
                    <li><strong>Current</strong> - One piece has become not only one of the most popular manga in Japan, but the best-selling manga series of all time.</li>
                </ul>
            </container>
            <br />
            <div>

                <p id="prgph">"Oda's plans place the ending of the One Piece manga around 2025-2026, though fans should note that this is no reliable indication of exactly when the anime - previously the fourteenth most popular TV show in the world, and consistently in the top five rated animated shows in Japan - will come to its closure." </p>
                <p>-- Robert Wood, screenrant.com</p>
                <p>If you're interested in learning more about who's behind of some of you're favorite shows, you may learn more about this artist in his <a href="https://en.wikipedia.org/wiki/Eiichiro_Oda" target="_blank" id="tribute-link">Wikipedia Page.</a> </p>
            </div>
        </div>
    )
}

export const TPAppWrapper = () => {
    return (
        <section id="TributePage" >
            <TributePage />
        </section>
    );
}

export default TributePage
